import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from '@/components/sections/Navbar';
import HeroSection from '@/components/sections/HeroSection';
import TrustSection from '@/components/sections/TrustSection';
import ServicesSection from '@/components/sections/ServicesSection';
import HowItWorks from '@/components/sections/HowItWorks';
import ResultsSection from '@/components/sections/ResultsSection';
import WhyChooseUs from '@/components/sections/WhyChooseUs';
import Testimonials from '@/components/sections/Testimonials';
import CTASection from '@/components/sections/CTASection';
import Footer from '@/components/sections/Footer';
import AdminPage from '@/components/admin/AdminPage';

const LandingPage = () => (
  <div className="min-h-screen bg-white">
    <Navbar />
    <HeroSection />
    <TrustSection />
    <ServicesSection />
    <HowItWorks />
    <ResultsSection />
    <WhyChooseUs />
    <Testimonials />
    <CTASection />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
